import { useState } from "react"
import "../Styles/Signup.css"
import { Input, PasswordInput, TextInput } from '@mantine/core';
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo3.jpg"

const ForgotPassword = () => {
    const navigate = useNavigate()
    
    return<>
        <section className="signup">
            <div className="signupWrapper">
                <img src={logo} alt="" />
                <form action="">
                    <div className="formHeading">
                        <h2>Forgot Password?</h2>
                        <p>Reset your farmcart password</p>
                    </div>

                    <div className="inputContainer">
                        <TextInput
                            label="Email Address:"
                            description="Enter your email address"
                            placeholder="abc@example.com"
                            type="email"
                            withAsterisk
                        />
                    </div>
                    <div className="buttonWrap">
                        <button className="btn">Send Code</button>
                        <button className="btn2" onClick={() => navigate("/signin")}>Back</button>

                    </div>
                </form>
            </div>
        </section>
    </>
}

export default ForgotPassword

